module.exports = __webpack_public_path__ + "img/CM-SL-CA-Subaru-Lifestyle.9a8db05f.jpg";